import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { can } from "@/lib/labels";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Cars from "@/pages/Cars";
import Pricelist from "@/pages/Pricelist";
import PublicPricelist from "@/pages/PublicPricelist";
import CarDetail from "@/pages/CarDetail";
import Purchases from "@/pages/Purchases";
import Costs from "@/pages/Costs";
import Sales from "@/pages/Sales";
import Operational from "@/pages/Operational";
import CashBook from "@/pages/CashBook";
import Branches from "@/pages/Branches";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";

function Protected({ children, adminOnly, perm }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to={homePath()} replace />;
  if (perm && !(Array.isArray(perm) ? perm : [perm]).some((p) => can(user, p))) return <Navigate to="/mobil" replace />;
  return children;
}

const PRICELIST_HOSTS = ["forzamobil.id", "www.forzamobil.id"];
const homePath = () => (PRICELIST_HOSTS.includes(window.location.hostname) ? "/dashboard" : "/");

function App() {
  const isPricelistHost = PRICELIST_HOSTS.includes(window.location.hostname);
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/pricelist-publik" element={<PublicPricelist />} />
            {isPricelistHost && <Route path="/" element={<PublicPricelist />} />}
            <Route element={<Protected><Layout /></Protected>}>
              {!isPricelistHost && <Route path="/" element={<Protected perm="lihat_laporan"><Dashboard /></Protected>} />}
              <Route path="/dashboard" element={<Protected perm="lihat_laporan"><Dashboard /></Protected>} />
              <Route path="/mobil" element={<Cars />} />
              <Route path="/pricelist" element={<Pricelist />} />
              <Route path="/mobil/:id" element={<CarDetail />} />
              <Route path="/pembelian" element={<Protected perm={["lihat_hpp", "kelola_pembelian"]}><Purchases /></Protected>} />
              <Route path="/biaya" element={<Costs />} />
              <Route path="/penjualan" element={<Sales />} />
              <Route path="/operasional" element={<Protected perm="input_biaya_operasional"><Operational /></Protected>} />
              <Route path="/buku-kas" element={<CashBook />} />
              <Route path="/cabang" element={<Branches />} />
              <Route path="/laporan" element={<Protected perm="lihat_laporan"><Reports /></Protected>} />
              <Route path="/pengguna" element={<Protected adminOnly><Users /></Protected>} />
              <Route path="/riwayat" element={<Protected adminOnly><AuditLog /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to={homePath()} replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
